module.exports = __webpack_public_path__ + "static/media/ico-linkedin.88a556f8.svg";